import React from 'react';
import PropTypes from 'prop-types';
import PrismicDom from 'prismic-dom';
import get from 'lodash/get';

import DangerousHTML from 'Components/Utility/DangerousHTML';

export default function BlogText({ elements }) {
  const html = PrismicDom.RichText.asHtml(elements, undefined, (
    elementType,
    element,
    content,
    children,
  ) => {
    if (elementType === 'image') {
      const { alt, url, linkTo } = element;
      return `
      <div class="justify-content-center responsive-image responsive-image--16by9 mb-4">
          ${linkTo && linkTo.url ? `<a
              href="${linkTo.url}"
              class="blog-link"
              ${!linkTo.url.startsWith('https://www.fanatical.com') ? 'target="_blank" rel="noopener noreferrer"' : ''}
              >` : ''}
          <img
            srcSet="
              ${url}${url.includes('?') ? '&' : '?'}w=880&fit=fillmax 880w,
              ${url}${url.includes('?') ? '&' : '?'}w=710&fit=fillmax 710w,
              ${url}${url.includes('?') ? '&' : '?'}w=680&fit=fillmax 680w,
              ${url}${url.includes('?') ? '&' : '?'}w=590&fit=fillmax 590w,
              ${url}${url.includes('?') ? '&' : '?'}w=500&fit=fillmax 500w
              ${url}${url.includes('?') ? '&' : '?'}w=400&fit=fillmax 400w
            "
            sizes="(min-width: 1520px) 872px, (min-width: 1200px) 740px, (min-width: 992px) 621px, (min-width: 768px) 704px, (min-width: 576px) 492px, 95vw"
            alt="${alt}"
            src="${url}"
            class="img-fluid blog-card-img"
            loading="lazy"
          />
        ${linkTo && linkTo.url ? '</a>' : ''}
      </div>`;
    }

    if (elementType === 'hyperlink') {
      const href = get(element, 'data.url', '');
      let stringifiedChildren = '';

      // hyperlinks that contain a href are inserting a comma into the dom where the child array seperates
      if (children && Array.isArray(children)) {
        children.forEach((c) => {
          stringifiedChildren = stringifiedChildren.concat(c);
        });
      }

      return `<a
      href="${href}"
      class="blog-link"
      ${!href.startsWith('https://www.fanatical.com') ? 'target="_blank" rel="noopener noreferrer"' : ''}
      >${(stringifiedChildren || content)}</a>`;
    }

    return null;
  });

  return (
    <DangerousHTML
      html={html}
    />
  );
}

BlogText.propTypes = {
  elements: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};
